class PlugStickyHeaderWrapper extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.headerSection = document.querySelector(".plug-header-section");
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia("(max-width: 990px)").addEventListener("change", this.setHeaderHeight.bind(this));

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.preventHide = false;

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.addEventListener("scroll", this.onScrollHandler, false);

        this.createObserver();
    }

    setHeaderHeight() {
        document.documentElement.style.setProperty("--plug-header-height", `${this.headerSection.offsetHeight}px`);
    }

    disconnectedCallback() {
        this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.removeEventListener("scroll", this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.headerSection);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.headerSection.classList.add("scrolled-past-header");
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.headerSection.classList.add("scrolled-past-header");
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.headerSection.classList.remove("scrolled-past-header");
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.headerSection.classList.add("plug-header-section-hidden", "plug-header-section-sticky");
        this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    reveal() {
        this.headerSection.classList.add("plug-header-section-sticky", "animate");
        this.headerSection.classList.remove("plug-header-section-hidden");
    }

    reset() {
        this.headerSection.classList.remove("plug-header-section-hidden", "plug-header-section-sticky", "animate");
    }

    closeMenuDisclosure() {
        // @todo
    }

    closeSearchModal() {
        // @todo
    }
}

customElements.define("plug-sticky-header-wrapper", PlugStickyHeaderWrapper);